import { render } from "./card_check_boxes.vue?vue&type=template&id=6c9c6410"
import script from "./card_check_boxes.vue?vue&type=script&lang=js"
export * from "./card_check_boxes.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__